import { IPaymentCharge } from "./PaymentChargeModel";
import { PaymentType } from "./PaymentType";

export default class Payment {
    PaymentToken: string;
    LastFour: string;
    IsValid: boolean;
    error: any;
    amount: number;
    transactionDate: string;
    paymentType: PaymentType;
    firstName: string;
    lastName: string;
    city: string;
    state: string;
    month: string;
    year: string;
    email: string;
    accountNumber: string;
    secondAccountNumber: string;
    routingNumber: string;
    method: string;
    bankType: string;
    bankHolderType: string;
    paymentCharge ?: IPaymentCharge
    hasBeenCharged : boolean
}
export enum BankHolderType {
    personal = "personal",
    business = "business"
}
export enum BankType {
    checking = "checking",
    savings = "savings"
}